import React, { useState } from 'react';
import { Merge } from 'lucide-react';
import { toast } from 'sonner';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from '../../ui/command';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const MergeWithButton = ({ vendor, vendors, onMerged }) => {
  const [open, setOpen] = useState(false);
  const others = vendors.filter(v => v.id !== vendor.id);

  const merge = async (target) => {
    if (!window.confirm(`¿Juntar "${vendor.name}" dentro de "${target.name}"?\n\nTodos sus gastos pasarán a "${target.name}" y "${vendor.name}" quedará como otro nombre del mismo proveedor.`)) return;
    const res = await fetch(`${API_URL}/api/admin/gastos/proveedores/unificar`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ canonical: target.name, members: [target.name, vendor.name] }),
    });
    const j = await res.json();
    if (!res.ok) return toast.error(j.detail || 'No se pudo juntar');
    toast.success(`Juntado en "${target.name}" (${j.updated_expenses} gastos)`);
    setOpen(false);
    onMerged();
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="p-1.5 rounded text-gray-400 hover:text-purple-700 hover:bg-purple-50" title="Juntar con otro proveedor" data-testid={`auth-vendor-merge-${vendor.id}`}>
          <Merge size={14} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-72" align="end">
        <p className="px-3 pt-3 pb-1 text-xs text-gray-500">Juntar <b>{vendor.name}</b> con…</p>
        <Command>
          <CommandInput placeholder="Buscar proveedor…" data-testid={`auth-vendor-merge-search-${vendor.id}`} />
          <CommandList className="max-h-60">
            <CommandEmpty>Ningún proveedor coincide</CommandEmpty>
            <CommandGroup>
              {others.map(o => (
                <CommandItem key={o.id} value={`${o.name} ${(o.aliases || []).join(' ')}`} onSelect={() => merge(o)} data-testid={`auth-vendor-merge-target-${o.id}`}>
                  <span className="truncate">{o.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
